// extracted by mini-css-extract-plugin
var _1 = "TableLinkCell-modulecontainer__yGAZU";
export { _1 as "container" }
